import React, { Component } from "react";
import Api from "./api";
import classes from "./C_Section1.module.css";

export default class BoxCareer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dummy: [
        { id: 1, name: "title", content: "Blog Đổi mới sáng tạo" },
        {
          id: 2,
          name: "content",
          content:
            "“Đổi mới sáng tạo” là một trong những giá trị cốt lõi của Tập đoàn Phenikaa. Với chúng tôi, đổi mới sáng tạo từ mỗi cá nhân, và sẽ được nhân lên với tinh thần sẻ chia, phản biện và hiện thực hóa bằng sức mạnh tập thể. Đây là nơi các chuyên gia, các nhà khoa học uy tín trao đổi về những sáng tạo trong lĩnh vực chuyên môn của họ, hướng tới việc tạo nên những giá trị ảnh hưởng sâu rộng tới Phenikaa nói riêng và cộng đồng xã hội nói chung. Và chính bạn cũng có thể nói lên quan điểm hay chia sẻ câu chuyện sáng tạo của chính mình cùng chúng tôi.",
        },
        {
          id: 3,
          name: "article",
          articles: [
            {
              name: "content1",
              author: "John doe x Jane doe",
              content:
                "THE INTRODUCTION CEREMONY OF THE TWO RESEARCH INSTITUTE OF PRATI & TIAS THE INTRODUCTION CEREMONY OF THE TWO RESEARCH INSTITUTE OF PRATI & TIAS",
              assets: require("../assets/default-image.svg"),
            },
            {
              name: "content2",
              author: "What is Lorem Ipsum?",
              content:
                "THE INTRODUCTION CEREMONY OF THE TWO RESEARCH INSTITUTE OF PRATI & TIAS",
              assets: require("../assets/default-image.svg"),
            },
            {
              name: "content2",
              author: "What is Lorem Ipsum?",
              content:
                "THE INTRODUCTION CEREMONY OF THE TWO RESEARCH INSTITUTE OF PRATI & TIAS",
              assets: require("../assets/default-image.svg"),
            },
          ],
        },
      ],
      contentArticle: {
        widgets: [],
      },
      counts: 0,
      url: "",
      readMore: "Read More",
      isLoaded: false,
      isApiLoaded: true,
    };
    this.getArticleDetail = this.getArticleDetail.bind(this);
  }

  componentDidMount() {
    if (this.props.id) {
      this.getArticleDetail(this.props.id);
    }
  }

  getArticleDetail(param) {
    const apiData = new Api();
    this.setState({ contentArticle: [] }, () => {
      apiData
        .getArticleDetailByYear(param, "", "", "")
        .then((result) => {
          const articles = result.data;
          const art = [];

          let count = articles.count;
          articles.results.forEach((a) => {
            const assets = [];

            a.article_assets.forEach((ass, i) => {
              if (i === 0) {
                assets.push({
                  asset: ass.asset_file,
                });
              }
            });

            art.push({
              id: a.id,
              category: a.category_name,
              name: a.name,
              title: a.article_languages.title,
              content: a.article_languages.content,
              assets: assets,
              date: a.date,
            });
          });

          this.setState({
            contentArticle: art,
            isLoaded: true,
            counts: count,
          });
        })
        .catch((error) => {
          console.log(error);
          this.setState({
            isApiLoaded: true,
          });
        });
    });
  }

  render() {
    const { contentArticle, isLoaded, isApiLoaded } = this.state;
    let availablePositions, availablePositionsText;

    if (isLoaded) {
      availablePositions = this.state.counts;
      availablePositionsText = this.props.avl ?this.props.avl : "Available" ;
    }

    return (
      <>
        <p className={classes.subtitle}>
          {availablePositions} {availablePositionsText}
        </p>
      </>
    );
  }
}
